module.exports = __webpack_public_path__ + "static/media/chester-wade.62a04e26.jpg";